import { render } from "./Aggiunte.vue?vue&type=template&id=c8274f42&scoped=true"
import script from "./Aggiunte.vue?vue&type=script&lang=js"
export * from "./Aggiunte.vue?vue&type=script&lang=js"

import "./Aggiunte.vue?vue&type=style&index=0&id=c8274f42&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8274f42"]])

export default __exports__